import React from 'react';

import cn from 'classnames';

import { TextEventRoleBadge } from '@entities/eventJournal/ui/TextEventRoleBadge';
import { UiText } from '@shared/ui';

import cls from './EventJournalAuthor.module.css';
import { TAuthor } from '../../model/types';

interface EventJournalAuthorProps {
    author: TAuthor;
    classes?: string;
    isExport?: boolean;
}

export const EventJournalAuthor = ({ author, classes, isExport }: EventJournalAuthorProps) => (
    <div className={cn(cls.author, classes)}>
        {!isExport && <img src={author.avatarUrl} alt={author.name} className={cls.avatar} />}
        <div className={cls.authorName}>
            <UiText tag="span" variant="caption">
                {author.name}
            </UiText>
        </div>
        <TextEventRoleBadge role={author.type} isExport={isExport} />
    </div>
);
